import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=5fdabf7e"
import script from "./Privacy.vue?vue&type=script&scoped=true&lang=js"
export * from "./Privacy.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=5fdabf7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports